<div class="fk-modal-container" [style]="{width, height}">
  <div class="fk-modal-container__header">
    <ng-container *ngTemplateOutlet="header || modalHeaderBase"></ng-container>
  </div>
  <div class="fk-modal-container__body">
    <ng-content></ng-content>
  </div>
  <div class="fk-modal-container__footer">
    <ng-container *ngTemplateOutlet="footer || modalFooterBase"></ng-container>
  </div>
</div>
<ng-template #modalHeaderBase>
  <div class="fk-modal-container__header-content">
    <p class="fk-modal-container__header-content-title fk-h6">{{ title }}</p>
    <button class="fk-modal-container__header-content-close fk-btn fk-btn-ghost" (click)="onCloseModal()">
      close
      <fk-icon name="close" [size]="24"></fk-icon>
    </button>
  </div>
</ng-template>

<ng-template #modalFooterBase>
  <div class="fk-modal-container__footer-content">
    <button
      (click)="onCloseModal()"
      class="fk-btn fk-btn-ghost fk-btn-medium"
    >cancel</button>
  </div>
</ng-template>
